import dedent from 'dedent';
import { z } from 'zod';
import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP, zodTDateISODate } from '~/lib/zod';

export type Reach = z.infer<typeof reachSchema>;

export const reachSchema = z.enum([
  '3,000',
  '5,000',
  '7,000',
  '9,250',
  '11,500',
  '14,000',
  '16,500',
  '20,000',
  '24,000',
]);

export const boostSchema = z.object({
  reach: reachSchema,
  start_at: zodTDateISODate('Boost start date is required'),
});

export default createPerformableConfig(
  'boost',
  {
    [FIRST_VERSION_TIMESTAMP]: z
      .object({
        version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
      })
      .merge(boostSchema),
  },
  {
    name: 'Social Media Boosting',
    group: 'Property Marketing',
    tenant: TenantId.BEYOND_RE_MARKETING,
    thumbnail: 'tenant/bre/boost/thumbnail_v4.jpg',
    images: [],
    short: dedent`
      Showcase your property with BayAreaHomeShowcase on Facebook and Instagram. Reach the \
      right buyers with stunning visuals, virtual tours, and key details. Strategic ads boost \
      visibility and target serious buyers. Whether for a quick sale or max exposure, social \
      media marketing delivers. Elevate your listing today!
    `,
  },
);
